module.exports = __webpack_public_path__ + "img/zk-icon-user.4f437c69.svg";